import { SxProp, ThemeUIStyleObject } from '@theme-ui/core';

export { Card, Container, Label, Checkbox } from '@theme-ui/components';
export type { CardProps } from '@theme-ui/components';
export { ThemeProvider, useThemeUI as useTheme } from '@theme-ui/core';
export type StyleProp = ThemeUIStyleObject;
export type Styled<T> = T & SxProp;
export { jsx } from '@theme-ui/core';
